export const routerPaths = {
  ROOT: "/",
  LOGIN: "/login",
  REGISTER: "/register",
  FORGOT_PASSWORD: "/forgot-password",
  AUTH_HANDLER: "/auth-handler",
  INSTRUCTOR: "/instructor",
  USERS: "/users",
  PROFILE: "/profile",
};
